import { FontSettings } from './baseFontSettings';
import { solidAshFontSettings } from './solidAshFontSettings';

export const solidMarbleFontSettings: FontSettings = { ...solidAshFontSettings };
